// ?use_ios_ui (2026-10-20) — one press of the D-pad as a wheel offset that
// follows the user's rotated view. The arrow is a screen vector, corrected
// into the rendered frame by the same rotateScreenDelta the touch drags use,
// then mapped with the shipped conventions: height positive up, horizontal
// positive toward screen-left (screenDragToOffsets negates dx).

import { rotateScreenDelta, type ScreenQuadrant } from '@/ar/touch-gestures'

export type TPadDirection = 'up' | 'down' | 'left' | 'right'

const SCREEN_VECTOR: Record<TPadDirection, { dx: number; dy: number }> = {
  up: { dx: 0, dy: -1 },
  down: { dx: 0, dy: 1 },
  left: { dx: -1, dy: 0 },
  right: { dx: 1, dy: 0 },
}

export function padStep({
  direction,
  quadrant,
  heightStep,
  horizontalStep,
}: {
  direction: TPadDirection
  quadrant: ScreenQuadrant
  heightStep: number
  horizontalStep: number
}): { height: number; horizontal: number } {
  const { dx, dy } = rotateScreenDelta({ ...SCREEN_VECTOR[direction], quadrant })
  // `+ 0` turns -0 into 0 so callers can test "this axis did not move".
  return { height: -dy * heightStep + 0, horizontal: -dx * horizontalStep + 0 }
}
